var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecruiter2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 265,
    viewBox: "0 0 288 265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hqg9a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M158.86 65.416l-8.058 6.419a1.668 1.668 0 0 1-2.683-1.07l-1.666-12.123a1.663 1.663 0 0 1 .85-1.664l8.442-4.616a1.668 1.668 0 0 1 2.449 1.254l1.283 10.319a1.663 1.663 0 0 1-.617 1.481z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M173.276 238.109s-4.443 12.671 1.833 15.223c6.276 2.552 31.346 8.993 49.002-3.473 0 0 .556-14.873-23.115-13.314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M173.276 238.109v0s-4.443 12.671 1.833 15.223c6.276 2.552 31.346 8.993 49.002-3.473 0 0 .556-14.873-23.115-13.314"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M146.43 215.151s-18.4 9.631-52.151 9.348c-33.752-.283-50.48-106.162-39.989-131.693 10.491-25.53 13.14-56.127 82.293-47.628 0 0 19.811 4.317 33.707 47.628s31.48 39.91 33.462 60.587c1.983 20.677-17.739 52.554-49.063 60.648"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M146.43 215.151v0s-18.4 9.631-52.151 9.348c-33.752-.283-50.48-106.162-39.989-131.693 10.491-25.53 13.14-56.127 82.293-47.628 0 0 19.811 4.317 33.707 47.628s31.48 39.91 33.462 60.587c1.983 20.677-17.739 52.554-49.063 60.648"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124.29 143.277c.25.527 12.33 24.483 32.257 19.828l.517-.128s7.609 73.608 15.029 76.443c7.42 2.835 24.198-2.691 24.198-2.691l-8.725-95.188s-1.86-14.164-15.473-15.484l-13.613-1.337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M124.29 143.277c.25.527 12.33 24.483 32.257 19.828l.517-.128v0s7.609 73.608 15.029 76.443c7.42 2.835 24.198-2.691 24.198-2.691v0l-8.725-95.188v0s-1.86-14.164-15.473-15.484l-13.613-1.337v0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.96 148.245c.25.522 12.335 24.477 32.257 19.822l.517-.127s7.609 73.613 15.034 76.442c7.426 2.83 24.199-2.69 24.199-2.69l-8.692-95.183s-1.86-14.17-15.473-15.49l-13.646-1.309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M108.96 148.245c.25.522 12.335 24.477 32.257 19.822l.517-.127v0s7.609 73.613 15.034 76.442c7.426 2.83 24.199-2.69 24.199-2.69v0l-8.692-95.183v0s-1.86-14.17-15.473-15.49l-13.646-1.309v0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M260.873 127.593l-1.772-.283-3.671 116.847 1.71-.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M260.873 127.593v0l-1.772-.283v0l-3.671 116.847v0l1.71-.128v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.093 243.993l-11.196-8.461-.467-114.572 15.679 5.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M255.093 243.993v0l-11.196-8.461v0l-.467-114.572v0l15.679 5.98v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M287.72 116.39L89.5 142.997l.022 7.833 198.198-26.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M287.72 116.39v0L89.5 142.997v0l.022 7.833v0l198.198-26.313v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M287.326 116.401L89.872 142.903l-52.301-18.114c-.367-.127-.311-.66-1.111-2.468L220.579 99.02l66.72 17.331s.044.05.027.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M287.326 116.401v0L89.872 142.903v0l-52.301-18.114c-.367-.127-.311-.66-1.111-2.468L220.579 99.02v0l66.72 17.331v0s.044.05.027.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M89.594 143.061L36.01 122.49l.2 8.266 53.334 20.127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M89.594 143.061v0L36.01 122.49v0l.2 8.266v0l53.334 20.127v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M129.075 111.684l42.355-6.701s-3.5-48.726-11.442-52.882c-7.942-4.155-32.046-11.711-32.046-11.711H115.63s-25.598 9.254-28.053 12.56c-2.455 3.307-3.216 34.468 0 52.221 3.216 17.753 5.765 20.1 5.765 20.1s16.545.471 31.196-9.82c14.652-10.29 18.528-17.092 20.989-19.545 0 0-10.775-10.574-11.347-13.081-.572-2.508-.283-.805-.283-.805s-24.576 15.218-27.153 17.953"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M129.075 111.684v0l42.355-6.701v0s-3.5-48.726-11.442-52.882c-7.942-4.155-32.046-11.711-32.046-11.711v0H115.63v0s-25.598 9.254-28.053 12.56c-2.455 3.307-3.216 34.468 0 52.221 3.216 17.753 5.765 20.1 5.765 20.1v0s16.545.471 31.196-9.82c14.652-10.29 18.528-17.092 20.989-19.545 0 0-10.775-10.574-11.347-13.081-.572-2.508-.283-.805-.283-.805v0s-24.576 15.218-27.153 17.953"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M148.687 90.104l-3.505 5.78L134.63 83.08l4.876-2.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M148.687 90.104v0l-3.505 5.78v0L134.63 83.08v0l4.876-2.94v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M121.58 30.968c8.106 0 14.678-6.933 14.678-15.484C136.258 6.932 129.686 0 121.58 0S106.9 6.932 106.9 15.484c0 8.551 6.572 15.484 14.68 15.484z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M115.633 40.689v.216c.122.976.905 5.126 5.437 8.355 0 0 1.172-1.454 3.51 0 0 0 1.522-1.026 2.727-4.283 0 0-.705-4.5.711-7.861 0 0 13.885-4.3 6.332-23.184 0 0 .627-10.769-8.242-13.032 0 0-.467 3.212-4.827 3.456-4.36.244-6.759-.577-6.759-.577s-5.96.106-5.07 6.802c0 0 5.992 2.585 1.949 11.578l-1.311.033-2.183-2.879s-4.293 1.415-1.316 6.269c2.977 4.854 3.938 1.204 3.938 1.204s1.488 6.408 6.381 8.677l-1.277 5.303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M115.633 40.689v.216c.122.976.905 5.126 5.437 8.355 0 0 1.172-1.454 3.51 0 0 0 1.522-1.026 2.727-4.283 0 0-.705-4.5.711-7.861 0 0 13.885-4.3 6.332-23.184 0 0 .627-10.769-8.242-13.032 0 0-.467 3.212-4.827 3.456-4.36.244-6.759-.577-6.759-.577v0s-5.96.106-5.07 6.802c0 0 5.992 2.585 1.949 11.578l-1.311.033v0l-2.183-2.879v0s-4.293 1.415-1.316 6.269c2.977 4.854 3.938 1.204 3.938 1.204v0s1.488 6.408 6.381 8.677l-1.277 5.303v0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M115.733 14.684c0-.038.028-.077.039-.11.011-.034-.028.05 0-.05l.078-.167c.144-.292.319-.567.522-.821a2.954 2.954 0 0 1 2.416-1.148 5.352 5.352 0 0 1 2.46.848.35.35 0 0 0 .35-.599c-1.294-.765-2.877-1.287-4.338-.654a4.13 4.13 0 0 0-1.943 1.897 4.359 4.359 0 0 0-.278.616c-.139.427.528.61.672.188z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M125.803 12.554c0-.038.028-.072.039-.11.011-.04 0 .055 0-.05l.078-.167c.144-.292.319-.567.522-.821a2.954 2.954 0 0 1 2.416-1.148 5.352 5.352 0 0 1 2.46.848.35.35 0 0 0 .356-.599c-1.3-.765-2.883-1.287-4.344-.654a4.208 4.208 0 0 0-1.943 1.897c-.11.2-.203.407-.278.621-.139.422.528.605.672.183z"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117.66 17.619s1.25-2.22 3.166-.594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M117.66 17.619s1.25-2.22 3.166-.594"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M118.63 16.858l.439.554a.372.372 0 0 0 .644-.138l.15-.594-.405.144-.3.045.088.332.167.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M118.63 16.858v0l.439.554a.372.372 0 0 0 .644-.138l.15-.594v0l-.405.144v0l-.3.045v0l.088.332v0l.167.128v0"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127.8 15.729s1.255-2.22 3.171-.594"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M127.8 15.729s1.255-2.22 3.171-.594"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128.77 14.972l.439.555a.361.361 0 0 0 .638-.139l.15-.588-.4.144-.305.045.094.332.162.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M128.77 14.972v0l.439.555a.361.361 0 0 0 .638-.139l.15-.588v0l-.4.144v0l-.305.045v0l.094.332v0l.162.128v0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M123.32 16.904a2.223 2.223 0 0 1 1.91-.239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M123.32 16.904a2.223 2.223 0 0 1 1.91-.239"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M124.683 18.848l1.872 2.574c.537.74 1.092 1.48 1.666 2.22.339.432.933.931 1.039 1.492.048.41-.068.822-.322 1.148a2.743 2.743 0 0 1-2.977 1.11c-.428-.14-.606.554-.184.665a3.336 3.336 0 0 0 3.033-.649c.722-.555 1.36-1.53 1.11-2.496a4.632 4.632 0 0 0-1.06-1.56c-.45-.554-.894-1.164-1.328-1.752l-.872-1.21-1.366-1.88c-.26-.361-.86 0-.6.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M118.645 28.307c.128.265.307.503.528.699.436.47.916.897 1.433 1.276a8.893 8.893 0 0 0 5.437 1.78c1.5-.06 2.972-.439 4.315-1.11.4-.193.05-.793-.35-.598-2.538 1.21-5.392 1.414-7.914.055a9.141 9.141 0 0 1-2.627-2.114 2.048 2.048 0 0 1-.117-.15c0-.005-.077-.16-.033 0a.35.35 0 0 0-.672.184z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.05 22.929s1.183-2.835 2.533 1.509"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M107.05 22.929s1.183-2.835 2.533 1.509"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140.006 97.11c.672 0 1.217-.567 1.217-1.265 0-.699-.545-1.265-1.217-1.265-.671 0-1.216.566-1.216 1.265 0 .698.545 1.265 1.216 1.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M140.006 97.11c.672 0 1.217-.567 1.217-1.265 0-.699-.545-1.265-1.217-1.265-.671 0-1.216.566-1.216 1.265 0 .698.545 1.265 1.216 1.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140.16 80.453c.106-.283 1.95-7.578 3.332-8.355 1.383-.776 4.4-3.883 4.4-3.883l.793 4.438s10.086-6.269 11.041-8.677c.956-2.407.145-2.269.145-2.269s1.844-1.11 1.738.638a15.246 15.246 0 0 1-1.16 5.787 11.51 11.51 0 0 1-1.961 2.968l3.021-5.315s1.978-1.06.522 4.605a27.067 27.067 0 0 1-1.766 4.96 13.534 13.534 0 0 1-1.955 3.15l3.794-7.44s.71-2.085.888 0a15.91 15.91 0 0 1-.483 3.845 58.423 58.423 0 0 1-.939 3.734l1.433-5.17c.182 1.432.238 2.879.167 4.321-.111 2.552-3.938 6.103-4.577 6.552-.638.45-8.802 5.42-9.497 5.842-.694.422-8.936-9.73-8.936-9.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M140.16 80.453c.106-.283 1.95-7.578 3.332-8.355 1.383-.776 4.4-3.883 4.4-3.883v0l.793 4.438v0s10.086-6.269 11.041-8.677c.956-2.407.145-2.269.145-2.269v0s1.844-1.11 1.738.638a15.246 15.246 0 0 1-1.16 5.787 11.51 11.51 0 0 1-1.961 2.968l3.021-5.315v0s1.978-1.06.522 4.605a27.067 27.067 0 0 1-1.766 4.96 13.534 13.534 0 0 1-1.955 3.15l3.794-7.44v0s.71-2.085.888 0a15.91 15.91 0 0 1-.483 3.845 58.423 58.423 0 0 1-.939 3.734v0l1.433-5.17c.182 1.432.238 2.879.167 4.321-.111 2.552-3.938 6.103-4.577 6.552-.638.45-8.802 5.42-9.497 5.842-.694.422-8.936-9.73-8.936-9.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F43F5F",
    d: "M158.86 65.416l-8.058 6.419a1.668 1.668 0 0 1-2.683-1.07l-1.666-12.123a1.663 1.663 0 0 1 .85-1.664l8.442-4.616a1.668 1.668 0 0 1 2.449 1.254l1.283 10.319a1.663 1.663 0 0 1-.617 1.481z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 20,
    strokeWidth: 2,
    d: "M158.86 65.416v0l-8.058 6.419a1.668 1.668 0 0 1-2.683-1.07l-1.666-12.123a1.663 1.663 0 0 1 .85-1.664l8.442-4.616a1.668 1.668 0 0 1 2.449 1.254l1.283 10.319a1.663 1.663 0 0 1-.617 1.481z",
    clipPath: "url(\"#hqg9a\")"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M122.78 54.603c1.324 0 2.399-1.277 2.399-2.851 0-1.575-1.075-2.852-2.4-2.852s-2.399 1.277-2.399 2.852c0 1.574 1.074 2.851 2.4 2.851z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M122.78 54.603c1.324 0 2.399-1.277 2.399-2.851 0-1.575-1.075-2.852-2.4-2.852s-2.399 1.277-2.399 2.852c0 1.574 1.074 2.851 2.4 2.851z"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M131.35 82.004c.095-5.853-6.176-26.724-6.176-26.724l-.444-1.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M131.35 82.004c.095-5.853-6.176-26.724-6.176-26.724v0l-.444-1.32v0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M105.54 75.03c.65 1.698 5.648 21.598 5.648 21.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M105.54 75.03c.65 1.698 5.648 21.598 5.648 21.598"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M217.379 110.967l-46.936 8.322a1.312 1.312 0 0 1-1.495-.938 1.308 1.308 0 0 1-.016-.638l9.897-43.733a1.314 1.314 0 0 1 1.11-1.01l46.987-6.657a1.312 1.312 0 0 1 1.46 1.598l-9.946 42.058a1.32 1.32 0 0 1-1.061.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M217.379 110.967v0l-46.936 8.322a1.312 1.312 0 0 1-1.495-.938 1.308 1.308 0 0 1-.016-.638l9.897-43.733a1.314 1.314 0 0 1 1.11-1.01l46.987-6.657a1.312 1.312 0 0 1 1.46 1.598l-9.946 42.058a1.32 1.32 0 0 1-1.061.998z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M168.91 119.434l-20.367-8.194-.033-.81 20.427 7.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M168.91 119.434v0l-20.367-8.194v0l-.033-.81v0l20.427 7.883v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M168.78 117.306l-18.95-7.423 24.604-1.293-5.104 7.528z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M168.78 117.306v0l-18.95-7.423v0l24.604-1.293v0l-5.104 7.528v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.133 264.453l-11.19-8.455-.473-114.578 15.684 5.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M76.133 264.453v0l-11.19-8.455v0L64.47 141.42v0l15.684 5.98v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.913 148.053l-1.777-.283-3.666 116.853 1.71-.134z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M81.913 148.053v0l-1.777-.283v0L76.47 264.623v0l1.71-.134v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M158.454 245.199s-4.415 12.671 1.833 15.223c6.248 2.552 31.347 8.993 49.003-3.473 0 0 .555-14.873-23.116-13.314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M158.454 245.199v0s-4.415 12.671 1.833 15.223c6.248 2.552 31.347 8.993 49.003-3.473 0 0 .555-14.873-23.116-13.314"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M184.26 243.2s18.245-4.61 24.26 9.841"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 20,
    d: "M184.26 243.2s18.245-4.61 24.26 9.841"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.656 250.003l-16.59-70.823-8.641-4.81H.28v70.823l8.642 4.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M44.656 250.003v0l-16.59-70.823v0l-8.641-4.81v0H.28v70.823l8.642 4.81v0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1818",
    d: "M27.5 179.396l-22.616.283L.98 174.93h18.011z"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.535 178.753s-3.971-12.038 6.948-29.458c10.919-17.42 4.399-34.397 2.977-37.537-1.422-3.14-3.571-8.643-3.7 0-.127 8.644 1.573 6.658-2.393 18.696-3.965 12.039-8.653 25.637-7.164 33.431a260.054 260.054 0 0 0 3.332 14.868z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M12.535 178.753v0s-3.971-12.038 6.948-29.458c10.919-17.42 4.399-34.397 2.977-37.537-1.422-3.14-3.571-8.643-3.7 0-.127 8.644 1.573 6.658-2.393 18.696-3.965 12.039-8.653 25.637-7.164 33.431a260.054 260.054 0 0 0 3.332 14.868z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.49 85.82c0 .155 15.657 3.129 12.469 40.243-3.072 35.728-6.876 48.088-2.844 50.946.157.11.325.207.5.288 4.832 2.22-1.11 0-1.11 0s-8.793-14.269-6.521-42.451c2.271-28.183 1.333-38.236-.556-43.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M1.49 85.82c0 .155 15.657 3.129 12.469 40.243-3.072 35.728-6.876 48.088-2.844 50.946.157.11.325.207.5.288 4.832 2.22-1.11 0-1.11 0v0s-8.793-14.269-6.521-42.451c2.271-28.183 1.333-38.236-.556-43.628"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.798 161.805c-1.517 0 10.396-5.759 40.46 8.782"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M95.798 161.805c-1.517 0 10.396-5.759 40.46 8.782"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.92 84.19s6.226 23.334 6.415 28.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 20,
    d: "M81.92 84.19s6.226 23.334 6.415 28.76"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruiter2);
export default __webpack_public_path__ + "static/media/recruiter2.38c95a161a02c34b009eae9f0f534f4b.svg";
export { ForwardRef as ReactComponent };